import { Injectable } from "@angular/core";
import { TramApiService } from "../tram-api.service";
import { StorageService } from "../storage.service";
import { AbstractEnhancedReview, Review, EnhancedReview, UsingMode, ModerationStatus, UserComment, CommentPack } from "../core/review";
import { State } from "../core/state";

import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { combineLatest } from 'rxjs/operators';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class ReviewService {
    private readonly _requestLimit = 5;
    private readonly _offset = 0;
    private _state: State;
    private idNamePairs: Map<string, string>;

    isEndReached: boolean = false;

    constructor(
        private api: TramApiService,
        private storage: StorageService) {
        this.idNamePairs = new Map<string, string>();

    }

    getReviewsPortion(nextPage: boolean = false): Promise<AbstractEnhancedReview[]> {
        let offset = this._offset;
        if (nextPage) {
            if (this._state.offset + this._state.count < this._state.total) {
                offset = this._state.offset + this._requestLimit;
            } else {
                this.isEndReached = true;
                return Promise.resolve([]);
            }
        }

        this.isEndReached = false;

        return this.api.getReviews(this._requestLimit, offset)
            .then(response => {
                this._state = response.state;

                let reviews = response.data
                    .map(r => {
                        const review = r as Review;
                        const eReview = new EnhancedReview(review);

                        return eReview;
                    });

                reviews = reviews.filter(r => r.base !== undefined);

                if (this._state.offset + this._state.count >= this._state.total)
                    this.isEndReached = true;

                return reviews;
            })
            .catch(error => { return Promise.resolve([]); });
    }

    moderate(review: AbstractEnhancedReview, comment: UserComment, status: ModerationStatus, message: string): Promise<any> {
        return this.api.moderateComment(review, comment.id, status, message)
            .then(raw => {
                review.updateComment(comment, raw);
            });
    }

    createReview(rate: number, message: string): Promise<AbstractEnhancedReview> {
        return this.api.createReview(rate, message)
            .then(raw => {
                const eReview = new EnhancedReview(raw);
                return eReview;
            });
    }
    createComment(review: AbstractEnhancedReview, comment: string): Promise<CommentPack> {
        return this.api.createComment(review.id, comment)
            .then(raw => {
                return review.addComment(raw);
            });
    }

    update(review: AbstractEnhancedReview, comment: UserComment, message: string): Promise<UserComment> {
        return this.api.updateComment(review.id, comment.id, message)
            .then(raw => {
                return review.updateComment(comment, raw);
            });
    }

    deleteReview(review: AbstractEnhancedReview): Promise<any> {
        return this.api.deleteReview(review.id);
    }
    deleteComment(review: AbstractEnhancedReview, comment: UserComment): Promise<any> {
        return this.api.deleteComment(review.id, comment.id)
            .then(result => {
                this._state.count--;
                this._state.offset--;
                this._state.total--;
                return result;
            });
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/providers/review.service.ts